module.exports = __webpack_public_path__ + "static/img/rank_256.ee8b539.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_256.png
// module id = qBp5
// module chunks = 0